import { Component, computed, effect, inject, untracked } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { RaadgivereService } from '../raadgivere.service';
import { RaadgiverSearchParams } from './raadgiver-search-params.model';
import { CheckboxModule } from 'primeng/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { handleBooleans } from '@core/form-utils';

@Component({
  selector: 'app-raadgiver-search',
  imports: [Button, ReactiveFormsModule, InputText, Message, CheckboxModule],
  templateUrl: './raadgiver-search.component.html',
  styleUrl: './raadgiver-search.component.css'
})
export class RaadgiverSearchComponent {
  raadgiverService = inject(RaadgivereService);
  data = this.raadgiverService.datasource.data;
  route = inject(ActivatedRoute);
  router = inject(Router);
  queryParams = toSignal(this.route.queryParams, { initialValue: {} });

  constructor() {
    this.reactOnQueryParamsChanged();
  }

  reactOnQueryParamsChanged() {
    effect(() => {
      const params = handleBooleans(this.queryParams());
      if (Object.values(params).length > 0) {
        untracked(() => {
          this.form.patchValue(params);
          this.raadgiverService.searchRaadgiver({
            ...(params as RaadgiverSearchParams),
            searchTime: new Date()
          });
        });
      }
    });
  }

  form = new FormGroup({
    navn: new FormControl(),
    regnr: new FormControl(),
    email: new FormControl(),
    brugerId: new FormControl(),
    formue: new FormControl(false),
    lts: new FormControl(false),
    fal: new FormControl(false)
  });

  onClickSearch() {
    this.router.navigate([],{queryParams: this.form.value});
  }

  onClickReset() {
    this.form.setValue({
      navn: null,
      regnr: null,
      email: null,
      brugerId: null,
      formue: false,
      lts: false,
      fal: false
    });
  }

  noHits = computed(() => {
    return (
      this.raadgiverService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });
}
